import React from 'react';

function WineryStateDropdownFilter({ handleChange }) {

    return (
        <div>
            <h3>Winery State</h3>
            <select className="form-control" onChange={e => handleChange(e.target.value, 'state')}>
                <option value="">All</option>
                <option value="Texas">Texas</option>
                <option value="California">California</option>
                <option value="Oregon">Oregon</option>
            </select>
        </div>
    );
}

export default WineryStateDropdownFilter;
